// src/components/TestLiveModeSwitch.jsx
import React, { useEffect, useState } from "react";

const TEST_COLOR = "#D97706";
const LIVE_COLOR = "#DC2626";

// This switch controls Smart Alert test/live mode and passes the selected mode color upward.
const TestLiveModeSwitch = ({ onToggle }) => {
  const [isLiveMode, setIsLiveMode] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem("test_live_mode");
    if (stored === "live") setIsLiveMode(true);
  }, []);

  const handleToggle = () => {
    const newValue = !isLiveMode;
    const nextMode = newValue ? "live" : "test";
    const nextColor = newValue ? LIVE_COLOR : TEST_COLOR;

    setIsLiveMode(newValue);
    localStorage.setItem("test_live_mode", nextMode);

    if (onToggle) {
      onToggle({ mode: nextMode, color: nextColor });
    }
  };

  return (
    <label style={styles.container}>
      <span
        style={{
          ...styles.label,
          color: isLiveMode ? LIVE_COLOR : TEST_COLOR,
        }}
      >
        {isLiveMode ? "Live Mode" : "Test Mode"}
      </span>

      <button
        type="button"
        aria-label={isLiveMode ? "Switch to Test Mode" : "Switch to Live Mode"}
        aria-pressed={isLiveMode}
        style={{
          ...styles.switch,
          backgroundColor: isLiveMode ? LIVE_COLOR : TEST_COLOR,
          boxShadow: `0 0 0 4px ${isLiveMode ? "rgba(220,38,38,0.12)" : "rgba(217,119,6,0.12)"}`,
        }}
        onClick={handleToggle}
      >
        <span
          style={{
            ...styles.ball,
            left: isLiveMode ? "21px" : "1px",
          }}
        />
      </button>
    </label>
  );
};

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    cursor: "pointer",
    userSelect: "none",
    margin: 0,
    padding: 0,
  },
  label: {
    fontSize: "14px",
    fontWeight: 900,
    margin: 0,
    padding: 0,
    lineHeight: 1.2,
    transition: "color 0.25s ease",
    whiteSpace: "nowrap",
  },
  switch: {
    width: "42px",
    height: "22px",
    borderRadius: "22px",
    position: "relative",
    transition: "background-color 0.25s ease, box-shadow 0.25s ease",
    boxSizing: "border-box",
    border: "none",
    padding: 0,
    cursor: "pointer",
    flex: "0 0 auto",
  },
  ball: {
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    backgroundColor: "#fff",
    position: "absolute",
    top: "2px",
    transition: "left 0.25s ease-in-out",
    left: "1px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.28)",
  },
};

export default TestLiveModeSwitch;
